interface MobileMapButtonProps {
  onClick: () => void;
}

/**
 * "Map" toggle shown on narrow screens only, where the search pages hide their
 * map sidebar. Opens the page's full-screen MobileMapOverlay.
 */
export const MobileMapButton = ({ onClick }: MobileMapButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="lg:hidden inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors"
  >
    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
      />
    </svg>
    Map
  </button>
);
